import KoalaTextBadge from 'koala/components/TextBadge';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import styled from 'styled-components';
import theme from 'theme';
import { Workspace } from 'types';
import { CustomTermKey, translate } from 'utils/customTermUtils';
import * as remoteApi from 'api/remote';
import yaml from 'js-yaml';
import queryKeys from 'config/queryKeys';
import { shallowEqual, useSelector } from 'react-redux';

const PregeneratedTemplateOption = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.x3} ${theme.spacing.x4};
  gap: ${theme.spacing.x2};
  align-items: center;

  border: solid 1px ${theme.colors.N20};
  border-radius: 8px;

  img {
    height: 173px;
  }

  :hover {
    background: ${theme.colors.B5};
    cursor: pointer;
  }
  :active {
    background: ${theme.colors.N10};
  }
`;

const PreviewContainer = styled.div`
  border: 2px dotted ${theme.colors.N50};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.x1};
  padding: ${theme.spacing.x2} ${theme.spacing.x2};
`;

const PreviewLine = styled.div`
  display: grid;
  grid-template-columns: 9rem 1fr;
  gap: ${theme.spacing.x1};

  div:first-of-type {
    justify-self: flex-end;
  }

  div:nth-of-type(2) {
    font-family: monospace, 'Courier New';
    font-size: 1.2rem;
  }
`;

interface Props {
  workspace: Workspace;
  templateCallback: (e: React.MouseEvent, yaml: string) => void;
}

function PreviewTemplate(props: Props) {
  const { workspace, templateCallback } = props;
  const [previewYml, setPreviewYml] = useState<any>();
  const currentMembership = useSelector((state: any) => state.session.currentMembership, shallowEqual);
  const queryKey = [queryKeys.currentMembership, currentMembership.id, 'ai_onboarding_plan'];
  useQuery(queryKey, remoteApi.fetchAiOnboardingPlan, {
    staleTime: 0,
    onSuccess: (response: any) => {
      setPreviewYml(response?.data);
    },
  });

  if (!previewYml) {
    return <></>;
  }

  let objectives = [];
  try {
    const content: any = yaml.load(previewYml.content);
    objectives = content;
  } catch (e) {}

  const handleClick = (e: React.MouseEvent) => {
    templateCallback(e, previewYml.content);
  };

  return (
    <PregeneratedTemplateOption onClick={handleClick}>
      <h3>Use the template we made just for you!</h3>
      <PreviewContainer>
        {objectives.map((objective: { objective: string; outcomes: string[] }) => (
          <>
            <PreviewLine>
              <div>
                <KoalaTextBadge size="small" variant="teal" edge="circle">
                  {translate(workspace, CustomTermKey.OBJECTIVE, 1)}
                </KoalaTextBadge>
              </div>
              <div>{objective['objective']}</div>
            </PreviewLine>
            {objective['outcomes'].map((outcome: string, index: number) => (
              <PreviewLine key={index}>
                <div>
                  <KoalaTextBadge size="small" variant="yellow" edge="circle">
                    #
                  </KoalaTextBadge>
                </div>
                <div>{outcome}</div>
              </PreviewLine>
            ))}
          </>
        ))}
      </PreviewContainer>
    </PregeneratedTemplateOption>
  );
}

export default PreviewTemplate;
